import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link } from "react-router-dom";

function MyNavbar() {
  return (
    <Navbar expand="lg" className="py-4">
      <Container>
        {/* Brand + Redes */}
        <div className="d-flex align-items-center">
          <Navbar.Brand as={Link} to="/" className="me-3 text-white">SM</Navbar.Brand>
         
          {/* Redes sociales */}
          <div className="d-flex gap-3">
            <a href="https://x.com/smenescaldi" target="_blank" rel="noopener noreferrer" className="text-white fs-5">
              <i className="bi bi-twitter-x"></i>
            </a>
            <a href="https://www.linkedin.com/in/smenescaldi/" target="_blank" rel="noopener noreferrer" className="text-white fs-5">
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div>

        {/* Botón hamburguesa y menú */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/bio" className="text-white">Bio</Nav.Link>
            <Nav.Link as={Link} to="/editoriales" className="text-white">Editoriales</Nav.Link>
            <Link to="/#media" className="nav-link text-white">Media</Link>
            <Link to="/#contacto" className="nav-link text-white">Contacto</Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;